import { IAccountingRule } from '@root/query'

export const isWorkflowOwnedRule = (
  rule?: Pick<IAccountingRule, 'workflow' | 'workflow_node_uuid'> | null
): boolean =>
  rule?.workflow != null &&
  rule.workflow !== 0 &&
  typeof rule.workflow_node_uuid === 'string' &&
  rule.workflow_node_uuid.length > 0
